<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="copyright pull-left">
        <a href="https://www.qualificationcheck.com/terms-and-conditions/" target="_blank">Terms & Conditions</a> | <a href="https://www.qualificationcheck.com/privacy-notice/" target="_blank">Privacy Notice</a> | <a href="https://www.qualificationcheck.com/cookie-policy/" target="_blank">Cookie Policy</a> | <a href="https://www.qualificationcheck.com/gdpr/" target="_blank">GDPR Notice</a> | <a href="https://www.qualificationcheck.com/contact/" target="_blank">Contact Us</a></br>
        Copyright &copy; 2025 Qualification Check &trade;, All Rights Reserved &reg;<br/>
        App v{{ applicationVersion }}<br/>
        API v{{ apiVersionNumber }}
      </div>
    </div>
  </footer>
</template>
<script>
  import { version } from "../../package.json"

  export default {
  data () {
    return {
      applicationVersion: version,
      apiVersionNumber: this.$store.state.apiVersionNumber,
    }
  },
  mounted() {
    this.$api.getApiVersionNumber()
    .then(response => {
      this.apiVersionNumber = response.data.version
    })
  }
}

</script>
<style>

</style>
